import { render, staticRenderFns } from "./UrgencyList.vue?vue&type=template&id=de7cea9a"
import script from "./UrgencyList.vue?vue&type=script&lang=js"
export * from "./UrgencyList.vue?vue&type=script&lang=js"
import style0 from "./UrgencyList.vue?vue&type=style&index=0&id=de7cea9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports